export const unloadingPlaceTypes = {
  FACTORY: 0,
  GROUPEDWAREHOUSE: 1,
  ADDRESS: 2,
  OTHERWAREHOUSE: 3,
};